import { navigate } from '@reach/router'
import React, { useEffect, useRef, useState } from 'react'
import { TemplateProps } from '../../../journeys/journey/Interfaces'
import { Checkbox, FormControlLabel, FormGroup, Typography, Box } from "@material-ui/core";
import { Button, Cards } from 'ams-ui-reactkit';
import { TitleBlock } from '../../../atoms';
import './CustomerVerify.scss'
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from '../../../context';
import { getParsedValue } from "./../../../common/ParseScript";
import { SignatureCard } from '../../../molecules';
import { getSignatureByIndex } from "./../../../common/GlobalUtils";
import { getCustomerId, getRandomNumber, calculateBase64SignSize } from '../../../utils/Utils';
import useSiganture from "../../BOL/DigitalSignature/useSiganture";
import DynamicHtml from "../../../molecules/DynamicHtml"
import { saveAckToDB } from '../../../graphql/saveAck.mutation';

const CustomerVerify: React.FC<TemplateProps> = (props: any) => {
    const { templateProps } = props;
    const [disabled, setDisabled] = useState(true);
    const customerId = getCustomerId() || ""
    const appState: any = useContextSelector(StoreContext, store => store?.appState);
    const signatures: any = useContextSelector(StoreContext, store => store?.appState?.signatures);
    const customerSignByInd = getSignatureByIndex(signatures?.list, 2);
    const carrierSignByInd = getSignatureByIndex(signatures?.list, 3);
    const [customerSign, setCustomerSign] = useState<any>(customerSignByInd?.getUrl || "");
    const [carrierSign, setCarrierSign] = useState<any>(carrierSignByInd?.getUrl || "");
    const customerSignRef = useRef<SignaturePad>(null);
    const carrierSignRef = useRef<SignaturePad>(null);
    
    const claimFillingRef = useRef<SignaturePad>(null);
    const claimFillingSignByInd = getSignatureByIndex(signatures?.list, 4);
    const [claimFillingSign, setClaimFillingSign] = useState<any>(claimFillingSignByInd?.getUrl || "");
    const [claimFillingSignSize, setClaimFillingSignSize] = useState<number>(0);

    const { callClearSignature, uploadSignature } = useSiganture();

    const [options, setOptions] = useState(templateProps?.checkList?.list || []);

    const [customerSignSize, setCustomerSignSize] = useState<number>(0);
    const [carrierSignSize, setCarrierSignSize] = useState<number>(0);

    const validateSignatureBySize = (process.env.REACT_APP_VALIDATE_SIGN_BY_SIZE === "true") ? true : false;
    const validSignatureSize = process.env.REACT_APP_SIGN_SIZE || 9000;

    const [isFormValid, setIsFormValid] = useState(false);
    const [invalidCustomerSignMessage, setInvalidCustomerSignMessage] = useState("");
    const [invalidCarrierSignMessage, setInvalidCarrierSignMessage] = useState("");
    const [invalidClaimFillingSignMessage, setInvalidClaimFillingSignMessage] = useState("");


    useEffect(() => {
        const selChecks = options.filter((option: any) => option.selected === undefined || option.selected === false);

        if (selChecks.length === 0) {
            setIsFormValid(true);
        } else {
            setIsFormValid(false);
        }

    }, [options]);


    useEffect(() => {

        let isButtonDisabled = true;
        //it will go to else block if any one of the sign get url is empty,
       //  this may cause some issues if we enable validateSignatureBySize
        if (isFormValid && customerSignByInd?.getUrl && customerSignSize !== 0 
            && carrierSignByInd?.getUrl && carrierSignSize !== 0
            && claimFillingSignByInd?.getUrl  && claimFillingSignSize !==0 ) {
            isButtonDisabled = false;
        }
        else if (isFormValid && customerSign && carrierSign && claimFillingSign) {
            isButtonDisabled = false;

            if (validateSignatureBySize && (customerSignSize <= validSignatureSize || carrierSignSize <= validSignatureSize || claimFillingSignSize <= validSignatureSize)) {
                isButtonDisabled = true;
            }
        }
        setDisabled(isButtonDisabled);

    }, [isFormValid, customerSignSize, carrierSignSize, claimFillingSignSize]);

    useEffect(() => {

        if (customerSignByInd?.getUrl) {
            const signSize = calculateBase64SignSize(customerSignByInd?.getUrl);
            setCustomerSignSize(signSize); // setting signature url as size to disable button on sign clear
        }
        if (carrierSignByInd?.getUrl) {
            const signSize = calculateBase64SignSize(carrierSignByInd?.getUrl);
            setCarrierSignSize(signSize);
        }
        if (claimFillingSignByInd?.getUrl) {
            const signSize = calculateBase64SignSize(claimFillingSignByInd?.getUrl);
            setClaimFillingSignSize(signSize);
        }


    }, []);


    const handleCustomerSignEnd = (evt: any) => {
        // @ts-ignore
        const signatureSize = calculateBase64SignSize(customerSignRef?.current?.getTrimmedCanvas()?.toDataURL());

        if (validateSignatureBySize && (signatureSize <= validSignatureSize)) {
            setInvalidCustomerSignMessage("We couldn't detect a Shipper/Customer signature.");

        } else {
            // @ts-ignore
            setCustomerSign(customerSignRef?.current?.getTrimmedCanvas()?.toDataURL() || "")
            setInvalidCustomerSignMessage("");
            setCustomerSignSize(signatureSize);
        }
    }

    const handleClaimFillingSignEnd = (evt: any) => {
        // @ts-ignore
        const signatureSize = calculateBase64SignSize(claimFillingRef?.current?.getTrimmedCanvas()?.toDataURL());

        if (validateSignatureBySize && (signatureSize <= validSignatureSize)) {
            setInvalidClaimFillingSignMessage("We couldn't detect a Shipper/Customer signature.");

        } else {
            // @ts-ignore
            setClaimFillingSign(claimFillingRef?.current?.getTrimmedCanvas()?.toDataURL() || "")
            setInvalidClaimFillingSignMessage("");
            setClaimFillingSignSize(signatureSize);
        }
    }


    const handleCarrierSignEnd = (evt: any) => {
        // @ts-ignore
        const signatureSize = calculateBase64SignSize(carrierSignRef?.current?.getTrimmedCanvas()?.toDataURL());

        if (validateSignatureBySize && (signatureSize <= validSignatureSize)) {
            setInvalidCarrierSignMessage("We couldn't detect a Carrier/Driver signature.");

        } else {
            // @ts-ignore
            setCarrierSign(carrierSignRef?.current?.getTrimmedCanvas()?.toDataURL() || "")
            setInvalidCarrierSignMessage("");
            setCarrierSignSize(signatureSize);
        }
    }

    const handleClick = (e: any) => {
        if (e?.target) {
            setOptions(options.map((option: any, idx: number) => {
                if (option.dataKey === e.target.value) {
                    return { ...option, selected: e.target.checked }
                }
                return option;
            }))
        }
    }

    const handleSaveAndContinue = async () => {
        let params: any = {
            customerId: customerId
        }
        options.forEach((option: any) => {
            params[option.dataKey] = option.selected ? 1 : 0
        })

        console.log("params:", params)

        saveAckToDB(params).then((dataResults: any) => {
            console.log("saveAckToDB RESULT", dataResults)
        }).catch((error: any) => {
            console.log("saveAckToDB Error:", error)
        })

        let customerSignResp, driverSignResp, caimFillingSignResp;


        if (customerSign && customerSignByInd && !customerSignByInd?.getUrl && customerSignByInd?.putUrl) {
            customerSignResp = await uploadSignature(customerSign, customerSignByInd);
        }

        if (carrierSign && carrierSignByInd && !carrierSignByInd?.getUrl && customerSignByInd?.putUrl) {
            driverSignResp = await uploadSignature(carrierSign, carrierSignByInd);
        }

        if (claimFillingSign && claimFillingSignByInd && !claimFillingSignByInd?.getUrl && claimFillingSignByInd?.putUrl) {
            caimFillingSignResp = await uploadSignature(claimFillingSign, claimFillingSignByInd);
        }

        Promise.all([customerSignResp, driverSignResp, caimFillingSignResp]).then((signatureRespArray) => {

            if (signatureRespArray?.length === 3 && signatureRespArray[0]?.ok && signatureRespArray[1]?.ok
                && signatureRespArray[2]?.ok) {
                navigate(templateProps?.nextScreen || '/')
            }

        });

    }

    const clearCustomerSignature = async () => {
        if (customerSignByInd && customerSignByInd?.getUrl && !customerSignByInd?.putUrl) {
            callClearSignature(customerSignByInd);
        }

        setCustomerSign("");
        setCustomerSignSize(0);
        setInvalidCustomerSignMessage("");
        customerSignRef?.current?.clear();
    }

    const clearCarrierSignature = async () => {
        if (carrierSignByInd && carrierSignByInd?.getUrl && !carrierSignByInd?.putUrl) {
            callClearSignature(carrierSignByInd);
        }

        setCarrierSign("");
        setCarrierSignSize(0);
        setInvalidCarrierSignMessage("");
        carrierSignRef?.current?.clear();
    }

    const clearClaimFillingSignature = async () => {
        if (claimFillingSignByInd && claimFillingSignByInd?.getUrl && !claimFillingSignByInd?.putUrl) {
            callClearSignature(claimFillingSignByInd);
        }

        setClaimFillingSign("");
        setClaimFillingSignSize(0);
        setInvalidClaimFillingSignMessage("");
        claimFillingRef?.current?.clear();
    }
    

    const checkBoxListBlock = () => {
        return options?.length > 0 && options.map((item: any, index: any) => {
            return <div key={index + getRandomNumber()} className='full-block mb-16'>
                <FormGroup row>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id={item.dataKey}
                                value={item.dataKey}
                                checked={item?.selected ? true : false}
                                onChange={(e: any) => handleClick(e)}
                            />
                        }
                        label={item.title}
                    />
                </FormGroup>
            </div>
        })
    }

    const CustomerSignBlock = () => {
        return <div><SignatureCard
            title={templateProps?.signCard?.title || ""}
            signRef={customerSignRef}
            onEnd={handleCustomerSignEnd}
            onBegin={() => { setInvalidCustomerSignMessage(""); }}
            sign={customerSign || ""}
            populate={customerSignByInd?.getUrl ? true : false}
            handleClearClick={clearCustomerSignature}
            signHere={templateProps?.signCard?.signHere || "SHIPPER/CUSTOMER SIGN HERE"}
        />
            <div className='color-red fw-500 mb-30' >{invalidCustomerSignMessage}</div>
        </div>
    }

    const CarrierSignBlock = () => {
        return <div><SignatureCard
            title={templateProps?.carrierSignCard?.title || ""}
            signRef={carrierSignRef}
            onEnd={handleCarrierSignEnd}
            onBegin={() => { setInvalidCarrierSignMessage(""); }}
            sign={carrierSign || ""}
            populate={carrierSignByInd?.getUrl ? true : false}
            handleClearClick={clearCarrierSignature}
            signHere={templateProps?.carrierSignCard?.signHere || "SHIPPER/CUSTOMER SIGN HERE"}
        />
            <span className='color-red fw-500' >{invalidCarrierSignMessage}</span>
        </div>
    }

    
    const ClaimFillingSignBlock = () => {
        return <Cards><SignatureCard
            title={templateProps?.signCard?.title || ""}
            signRef={claimFillingRef}
            onEnd={handleClaimFillingSignEnd}
            onBegin={() => { setInvalidClaimFillingSignMessage(""); }}
            sign={claimFillingSign || ""}
            populate={claimFillingSignByInd?.getUrl ? true : false}
            handleClearClick={clearClaimFillingSignature}
            signHere={templateProps?.signCard?.signHere || "SHIPPER/CUSTOMER SIGN HERE"}
        />
            <div className='color-red fw-500 mb-30' >{invalidClaimFillingSignMessage}</div>
        </Cards>
    }

    return (
        <div className="baseContainerBlock customerVerify">
            {templateProps.title && <TitleBlock title={getParsedValue(templateProps?.title, appState)} />}
            <Typography variant='subtitle2' color='textPrimary' noWrap={false} align='center' className="color-green mt-8 mb-16">
                {templateProps?.subtitle}
            </Typography>

            <Cards variant="default">
                <div className="customer_verify">
                    <div className="primaryVerify_Block">
                        {templateProps?.checkList &&
                            <div>
                                {templateProps?.checkList?.title && <Typography variant='h6' color='textPrimary' noWrap={false} align='left' className='mb-16'>
                                    {templateProps?.checkList?.title}
                                </Typography>}
                                {
                                    checkBoxListBlock()
                                }
                            </div>
                        }
                    </div>
                    
                    <div className="secondaryVerify_Block">
                        {templateProps?.processConfirm && <div>
                            {templateProps?.processConfirm?.title && <Typography variant='h6' color='textPrimary' noWrap={false} align='left' className='mb-16 color-grey'>
                                {templateProps?.processConfirm?.title}
                            </Typography>}
                            <Typography variant='caption' color='textPrimary' noWrap={false} align='left' className='f-left color-grey'>
                                {templateProps?.processConfirm?.content}
                            </Typography>

                            <Typography variant='subtitle2' color='textPrimary' noWrap={false} align='center' className="color-green full-block mt-16">
                                <DynamicHtml content={templateProps?.processConfirm?.footerText} />
                            </Typography>
                            
                        </div>}
                    </div>

                </div>
            </Cards>
            <Cards variant="default">
                <div className=" claimBox ">
                {templateProps?.claimFilling && <div className=" secondary_Block">
                        <Box>
                            {templateProps?.claimFilling?.title && <Typography variant='h6' component="div" gutterBottom color='textPrimary' noWrap={false} align='left' className='mb-16 color-grey'>
                                {templateProps?.claimFilling?.title}
                            </Typography>}
                            <Typography variant='h6' component="div" color='textPrimary' noWrap={false} align='left'>
                                {templateProps?.claimFilling?.content}
                            </Typography>
                            {templateProps?.claimFilling?.list && <ol>
                                {templateProps?.claimFilling?.list?.map((item: any) =>
                                    <li className='list-item'>{item?.title}</li>
                                )}
                            </ol>}
                            {templateProps?.claimFilling?.footerTitle && <Typography variant='subtitle2' component="div" color='textPrimary' noWrap={false} align='left' className='color-grey'>
                                {templateProps?.claimFilling?.footerTitle}
                               
                            </Typography>}
                            <Typography variant='subtitle2' align='left' noWrap={false} className="mb-16">
                                <DynamicHtml content={templateProps?.claimFilling?.footerText} />
                            </Typography>
                           
                            {ClaimFillingSignBlock()}
                        </Box>
                    
                    </div>
                }
                </div>
            </Cards>
            {CustomerSignBlock()}
            {CarrierSignBlock()}

            <div className="staticFixedButton">
                <Button
                    text={templateProps?.button}
                    onClick={handleSaveAndContinue}
                    color="primary"
                    variant="contained"
                    disabled={disabled}
                    size="large"
                />
            </div>
        </div>
    )
}

export default CustomerVerify